const iemPrice = (state = {}, action) => {
    function renderTotal(curr) {
        return (
            curr.base +
            (curr.faceplate.left + curr.faceplate.left * process.env.REACT_APP_TAX_RATE) +
            (curr.faceplate.right + curr.faceplate.right * process.env.REACT_APP_TAX_RATE) +
            (curr.artwork.left + curr.artwork.left * process.env.REACT_APP_TAX_RATE) +
            (curr.artwork.right + curr.artwork.right * process.env.REACT_APP_TAX_RATE) +
            +curr.carePlan +
            +curr.rush
        );
    }

    let curr;
    let total = 0;
    switch (action.type) {
        case 'SET_IEM_PRICE':
            // let total = (parseInt(action.payload.price, 10) + parseInt(action.payload.default_options.faceplate.price, 10) + parseInt(action.payload.default_options.artwork.price, 10))
            curr = {
                ...state,
                base: parseInt(
                    action.payload.shopify.price
                        ? action.payload.shopify.price
                        : action.payload.iem.price,
                    10
                ),
                faceplate: {
                    left: parseInt(action.payload.iem.default_options.faceplate.price, 10),
                    right: parseInt(action.payload.iem.default_options.faceplate.price, 10)
                },
                artwork: {
                    left: parseInt(action.payload.iem.default_options.artwork.price, 10),
                    right: parseInt(action.payload.iem.default_options.artwork.price, 10)
                },
                rush: 0,
                carePlan: 0
            };
            total = renderTotal(curr);
            curr.total = total;
            return curr;
        case 'SET_LEFT_FACEPLATE_PRICE':
            curr = {
                ...state,
                faceplate: {
                    left: parseInt(action.payload.price, 10),
                    right: state.faceplate.right
                }
            };
            total = renderTotal(curr);
            curr.total = total;
            return curr;
        case 'SET_RIGHT_FACEPLATE_PRICE':
            curr = {
                ...state,
                faceplate: {
                    left: state.faceplate.left,
                    right: parseInt(action.payload.price, 10)
                }
            };
            total = renderTotal(curr);
            curr.total = total;
            return curr;
        case 'SET_BOTH_FACEPLATE_PRICE':
            curr = {
                ...state,
                faceplate: {
                    left: parseInt(action.payload.price, 10),
                    right: parseInt(action.payload.price, 10)
                }
            };
            total = renderTotal(curr);
            curr.total = total;
            return curr;
        case 'SET_LEFT_ARTWORK_PRICE':
            curr = {
                ...state,
                artwork: {
                    right: state.artwork.right,
                    left: parseInt(action.payload.price, 10)
                }
            };
            total = renderTotal(curr);
            curr.total = total;
            return curr;
        case 'SET_RIGHT_ARTWORK_PRICE':
            curr = {
                ...state,
                artwork: {
                    left: state.artwork.left,
                    right: parseInt(action.payload.price, 10)
                }
            };
            total = renderTotal(curr);
            curr.total = total;
            return curr;
        case 'SET_BOTH_ARTWORK_PRICE':
            curr = {
                ...state,
                artwork: {
                    left: parseInt(action.payload.price, 10),
                    right: parseInt(action.payload.price, 10)
                }
            };
            total = renderTotal(curr);
            curr.total = total;
            return curr;
        case 'UPDATE_BASE_PRICE':
            curr = {
                ...state,
                base: parseInt(action.payload.price, 10)
            };
            total = renderTotal(curr);
            curr.total = total;
            return curr;
        case 'SET_CARE_PLAN_PRICE':
            curr = {
                ...state,
                carePlan: parseInt(action.payload.price, 10)
            };
            total = renderTotal(curr);
            curr.total = total;
            return curr;
        case 'SET_RUSH_PROCESSING_PRICE':
            if (action.payload === 0 || action.payload === undefined || action.payload === '') {
                curr = {
                    ...state,
                    rush: 0
                };
                total = renderTotal(curr);
                curr.total = total;
                return curr;
            } else {
                curr = {
                    ...state,
                    rush: parseInt(action.payload)
                };
            }
            total = renderTotal(curr);
            curr.total = total;
            return curr;
        default:
            return state;
    }
};

export default iemPrice;
